var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F4F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M17.75 14.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm-5.625 0a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M21.125 17.75h.563a2.25 2.25 0 0 1 2.23 1.955l3.5-1.555A1.125 1.125 0 0 1 29 19.178v8.394c0 .814-.838 1.359-1.582 1.028l-3.5-1.555A2.25 2.25 0 0 1 21.688 29H13.25A2.25 2.25 0 0 1 11 26.75V20a2.25 2.25 0 0 1 2.25-2.25h7.875Zm6.75 9.822v-8.394l-3.938 1.75v4.894l3.938 1.75ZM12.125 20v6.75c0 .621.504 1.125 1.125 1.125h8.438c.62 0 1.125-.504 1.125-1.125V20c0-.621-.504-1.125-1.125-1.125H13.25c-.621 0-1.125.504-1.125 1.125Zm9-2.25a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75Zm-2.25-3.375a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv);
export default __webpack_public_path__ + "static/media/av.2b64756b82d2baec42f3ffcda058601b.svg";
export { ForwardRef as ReactComponent };